import React from 'react';
import { Carousel } from 'primereact/carousel';
import BaseChart from '../form/BaseChart.jsx';

const KPIsBalanceSheetCarousel = ({ years, balanceSheet, lineLogarithmicOptions, defaultLogarithmicOptions }) => {
    const totalAssets = balanceSheet.map((entry) => Number(entry.totalAssets)).reverse();
    const currentAssets = balanceSheet.map((entry) => Number(entry.totalCurrentAssets)).reverse();
    const nonCurrentAssets = balanceSheet.map((entry) => Number(entry.totalNonCurrentAssets)).reverse();
    const cashAndEquivalents = balanceSheet
        .map((entry) => Number(entry.cashAndCashEquivalentsAtCarryingValue))
        .reverse();
    const inventory = balanceSheet.map((entry) => Number(entry.inventory)).reverse();

    const totalLiabilities = balanceSheet.map((entry) => Number(entry.totalLiabilities)).reverse();
    const currentLiabilities = balanceSheet.map((entry) => Number(entry.totalCurrentLiabilities)).reverse();
    const nonCurrentLiabilities = balanceSheet.map((entry) => Number(entry.totalNonCurrentLiabilities)).reverse();
    const totalDebt = balanceSheet.map((entry) => Number(entry.shortLongTermDebtTotal)).reverse();

    const totalShareholderEquity = balanceSheet.map((entry) => Number(entry.totalShareholderEquity)).reverse();
    const retainedEarnings = balanceSheet.map((entry) => Number(entry.retainedEarnings)).reverse();
    const commonStock = balanceSheet.map((entry) => Number(entry.commonStock)).reverse();

    const chartItems = [
        {
            id: 'assets-over-time',
            title: 'Assets Over Time',
            type: 'line',
            options: lineLogarithmicOptions(),
            data: {
                labels: years,
                datasets: [
                    { label: 'Total Assets', tension: 0.4, borderColor: '#B3D100', fill: false, data: totalAssets },
                    { label: 'Current Assets', tension: 0.4, borderColor: '#4E86DE', fill: false, data: currentAssets },
                    {
                        label: 'Non-Current Assets',
                        tension: 0.4,
                        borderColor: '#FFA239',
                        fill: false,
                        data: nonCurrentAssets
                    }
                ]
            }
        },
        {
            id: 'liabilities-over-time',
            title: 'Liabilities Over Time',
            type: 'line',
            options: lineLogarithmicOptions(),
            data: {
                labels: years,
                datasets: [
                    {
                        label: 'Total Liabilities',
                        tension: 0.4,
                        borderColor: '#FFA239',
                        fill: false,
                        data: totalLiabilities
                    },
                    {
                        label: 'Current Liabilities',
                        tension: 0.4,
                        borderColor: '#D03C50',
                        fill: false,
                        data: currentLiabilities
                    },
                    {
                        label: 'Non-Current Liabilities',
                        tension: 0.4,
                        borderColor: '#A05514',
                        fill: false,
                        data: nonCurrentLiabilities
                    }
                ]
            }
        },
        {
            id: 'equity-over-time',
            title: 'Shareholder Equity Over Time',
            type: 'line',
            options: lineLogarithmicOptions(),
            data: {
                labels: years,
                datasets: [
                    {
                        label: 'Total Shareholder Equity',
                        tension: 0.4,
                        borderColor: '#4E86DE',
                        fill: false,
                        data: totalShareholderEquity
                    },
                    {
                        label: 'Retained Earnings',
                        tension: 0.4,
                        borderColor: '#00D2B3',
                        fill: false,
                        data: retainedEarnings
                    },
                    { label: 'Common Stock', tension: 0.4, borderColor: '#879D00', fill: false, data: commonStock }
                ]
            }
        },
        {
            id: 'debt-breakdown',
            title: 'Debt Breakdown Over Time',
            type: 'bar',
            options: defaultLogarithmicOptions('Debt Breakdown by Year'),
            data: {
                labels: years,
                datasets: [
                    { label: 'Total Debt', backgroundColor: '#D03C50', data: totalDebt },
                    { label: 'Total Liabilities', backgroundColor: '#FFA239', data: totalLiabilities }
                ]
            }
        },
        {
            id: 'assets-breakdown',
            title: 'Asset Composition Over Time',
            type: 'bar',
            options: defaultLogarithmicOptions('Asset Composition by Year'),
            data: {
                labels: years,
                datasets: [
                    { label: 'Cash & Equivalents', backgroundColor: '#4E86DE', data: cashAndEquivalents },
                    { label: 'Inventory', backgroundColor: '#B3D100', data: inventory }
                ]
            }
        }
    ];

    const chartTemplate = (chart) => {
        return (
            <div className='w-full flex md:justify-center'>
                <div className='w-full md:w-3/4 lg:w-full xl:w-full'>
                    <BaseChart
                        type={chart.type}
                        id={chart.id}
                        title={chart.title}
                        options={chart.options}
                        childClassName='bg-theme1-white p-4 rounded-2xl'
                        className={'mb-6 shadow-lg rounded-2xl mx-3'}
                        data={chart.data}
                    />
                </div>
            </div>
        );
    };

    return (
        <Carousel
            className={'mx-[-10px]'}
            value={chartItems}
            numScroll={1}
            numVisible={1}
            itemTemplate={chartTemplate}
            showNavigators={false}
            circular={false}
            showIndicators
        />
    );
};

export default KPIsBalanceSheetCarousel;
